import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import type { ICaaOrder } from "@repo/shopify/queries/customer-account-gql";
import type { IOrdersEdgesNode } from "@repo/shopify/queries/customer-gql";

import Link from "@atoms/Link";
import Loading from "@atoms/Loading";

import OrderHistoryCard from "@organisms/OrderHistoryCard";
import OrderHistoryCardJp from "@organisms/OrderHistoryCardJp";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";
import useOrders from "@hooks/useOrders";

export default function OrderHistory() {
  const { t } = useTranslation();
  const { lang } = useLanguage();
  const isJp = lang === "jp";

  const { initialLoading, hasNextPage, loaderEl, orders } = useOrders(isJp);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {initialLoading ? (
        <Loading type="page" />
      ) : (
        <section className="pc:col-span-10 pc:grid-cols-subgrid col-span-8 grid grid-cols-subgrid gap-y-2.5">
          {orders.length ? (
            <ul className="pc:col-span-10 pc:grid-cols-subgrid col-span-8 grid grid-cols-subgrid gap-y-10">
              {orders.map(({ node }) =>
                isJp ? (
                  <OrderHistoryCardJp key={node.id} node={node as ICaaOrder} />
                ) : (
                  <OrderHistoryCard key={node.id} node={node as IOrdersEdgesNode} />
                ),
              )}
            </ul>
          ) : (
            <div className="pc:col-span-10 col-span-8 flex flex-col gap-5">
              <p>{t("order_history.empty")}</p>
              <Link as="square" href={URLS.COLLECTIONS_ALL} variant="secondary">
                Continue Shopping
              </Link>
            </div>
          )}
          <div className="pc:col-span-10 col-span-8" ref={loaderEl} />
          {hasNextPage ? <Loading /> : null}
        </section>
      )}
    </>
  );
}
